import { createFileRoute } from "@tanstack/react-router";

import { parseDebugSearch } from "~/features/game/components/ScoreTakingDebugView/scoreTakingDebugSearch.ts";
import {
    resolveDebugSelection,
    toDebugSearch,
} from "~/features/game/components/ScoreTakingDebugView/scoreTakingDebugUtils.ts";
import { ScoreTakingDebugView } from "~/features/game/components/ScoreTakingDebugView/ScoreTakingDebugView.tsx";

const ScoreTakingDebugPage = () => {
    const navigate = Route.useNavigate();
    const selection = resolveDebugSelection(Route.useSearch());

    return (
        <ScoreTakingDebugView
            {...selection}
            onChange={(change) => {
                navigate({ search: toDebugSearch({ ...selection, ...change }), replace: true });
            }}
        />
    );
};

export const Route = createFileRoute("/_auth/dev/score-taking/")({
    validateSearch: parseDebugSearch,
    component: ScoreTakingDebugPage,
});
